module.exports = __webpack_public_path__ + "static/media/device.06aa09b9.png";